'use strict';

const { alertMessage } = require('../common/common');

module.exports = {
    submitLead: function () {
        $('form.lead-generation-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (data && data.success) {
                        alertMessage(data.message, 'cc-alert--success');
                    } else if (data && !data.success && data.message) {
                        alertMessage(data.message, 'cc-alert--danger');
                    } else if (data && !data.success && data.errorMessage) {
                        alertMessage(data.errorMessage, 'cc-alert--danger');
                    }
                },
                error: function (err) {
                    $form.spinner().stop();
                    alertMessage(err.responseJSON.error.errorText, 'cc-alert--danger');
                }
            });
            return false;
        });
    },
};
